import React from "react";
import AbstractItemsTableWithLoader from '../Tables/AbstractItemsTableWithLoader';
import {fetchFeedbackMovements} from '../services';
import {Link} from 'react-router-dom';

const FeedbackMovementsTable = () => {

    const tableColumns = {
        key: 'ID',
        type: 'Type',
        status: 'Status',
        amount: 'Amount',
        currency: 'Currency',
        name: 'Name',
        account: 'Account',
        feedbackFile: 'FeedbackFile',
        communication: 'Communication',
    };

    const namedSearchParameters = {
        dateCreated: {
            type: 'date',
            name: 'Created date',
            operators: ['eq', 'lt', 'gt', 'between'],
        },
        feedbackFileIban: {
            type: 'feedbackFileIban',
            name: 'IBAN',
            operators: ['eq', 'contains'],
        },
        status: {
            type: 'select',
            name: 'Status',
            options: ['UNHANDLED', 'MARKED_AS_HANDLED', 'REFUNDED', 'FORWARDED', 'IGNORED'],
            operators: ['eq'],
            multiple: true,
        },
        type: {
            type: 'select',
            name: 'Type',
            options: ['CREDIT', 'DEBIT'],
            operators: ['eq'],
            multiple: true,
        },

    };

    const fetchFunction = (searchParams: any) => {
        return fetchFeedbackMovements(searchParams).then(data => ({
            ...data,
            items: data.items.map((item: any) => ({
                ...item,
                key: <Link to={`/feedback-movements/${item.key}`}>{item.key}</Link>,
                feedbackFile: <div>
                    <div>IBAN: {item.feedbackFileIban}</div>
                    <div>Opening Balance: {item.openingBalance}</div>
                    <div>Closing Balance: {item.closingBalance}</div>
                    <div>FeedbackDate: {item.feedbackFileCreated}</div>
                </div>
            })),
        }));
    };

    return <AbstractItemsTableWithLoader
        tableColumns={tableColumns}
        namedSearchParameters={namedSearchParameters}
        fetchFunction={fetchFunction}
        autoWidthColumns={['key', 'status', 'type', 'communication', 'amount', 'name', 'currency', 'feedbackFile', 'account']}

    />;
};

export {
    FeedbackMovementsTable
};
